<!--
 * @Description: 申请提交成功
--> 
<template>
  <div class="meter-transfer-success">
    <van-nav-bar
      :title="$route.meta.title"
      @click-left="$comm.onClickLeft"
      fixed
      >
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div style="height:100px;"></div>
    <div class="main">
      <div class="main-title">
        <div class="iconfont iconwancheng"></div>
        <div class="main-title-txt">{{$route.query.from==='业务办理'?'业务申请提交成功！':'客户服务单提交成功！'}}</div>
      </div>
      <div class="main-content">
        您所申请的
        <span class="main-content-txt">{{$route.query.title}}</span>
        业务已提交成功，符合条件的，我们尽快办理！您的办理进度或结果可登录网上营业厅
        <span class="main-content-txt">{{$route.query.from==='业务办理'?'“业务办理进度查询”':'客户服务工单查询'}}</span>查看，我们也将以短信或电话形式通知您登记的手机号码。
      </div>
    </div>
    <van-button
      type="info"
      color="#1677FF"
      size="large"
      style="margin-top:23px;height:44px;"
      @click="progressClick()"
      >
      返回受理进度
    </van-button>
  </div>
</template>

<script>
export default {
  name: 'MeterTransferSuccess',
  components: {
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    progressClick(){
      let path = ''
      if(this.$route.query.from==='业务办理'){
        path = '/mine/businessProgress'
      }else if(this.$route.query.from==='水管家服务'){
        path = this.$route.query.path
      }else{
        path = '/mine/butlerProgress'
      }
      this.$router.push({
        path: path,
        query: {
          typeCode: this.$route.query.typeCode
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.meter-transfer-success{
  background:rgba(255,255,255,1);
  padding: 0 16px;
  // padding-bottom: 52px;
  height: 100%;
  .main{
    .main-title{
      color: #2C82C9;
      text-align: center;
      .iconfont{
        font-size: 80px;
      }
      .main-title-txt{
        font-size:21px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
      }
    }
    .main-content{
      margin-top: 44.5px;
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(33,33,33,1);
      padding: 0 5px;
      text-align: center;
      .main-content-txt{
        font-weight: bold;
      }
    }
  }
}
</style>